module.exports = __webpack_public_path__ + "img/cta_disabled.88708832.svg";